import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TCalendlyType } from '@src/shared/types/calendly-types';

export function LeadCalendlyTypeFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TCalendlyType>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      {item.name}
    </FilterOptionItem>
  );
}
